export const SmartContractDevelopmentProcessData = {
  mainText: `Our Smart Contract Development Process`,
  description: `We follow a proven methodology that eliminates the common pitfalls that sink most smart contract projects. Every step is designed to catch issues early, optimize for real-world usage, and ensure your contracts perform flawlessly from day one.`,
  services: [
    {
      step: '1',
      title: 'Business Logic Architecture',
      description:
        'Understanding your requirements and designing contracts for real-world usage patterns',
      stepColor: 'orange',
    },
    {
      step: '2',
      title: 'Security-First Development',
      description:
        'Writing bulletproof code with continuous internal auditing throughout development',
      stepColor: 'orange',
    },
    {
      step: '3',
      title: 'Comprehensive Testing',
      description:
        'Unit tests, integration tests, and stress testing against edge cases and attacks',
      stepColor: 'orange',
    },
    {
      step: '4',
      title: 'Deployment & Monitoring',
      description:
        'Launch with full observability systems and ongoing performance optimization',
      stepColor: 'orange',
    },
  ],
};
